// While a game is being played on a phone, the bottom bar steps aside so the
// game has the whole screen. It comes back on the start and result screens.
import { useEffect } from 'react';

export default function useGameFullscreen(active) {
  useEffect(() => {
    document.body.classList.toggle('game-fullscreen', !!active);
    return () => document.body.classList.remove('game-fullscreen');
  }, [active]);
}
